<div class="row mt-4">
  <div class="col-md-12">
    <div class="row mb-3">
      <div class="col-5 mr-auto">
        <h3>Keyword's Affiliate Management</h3>
      </div>
      <div class="col-2 ml-auto text-right">
        <a class="btn btn-outline-default"  (click)="back()">
          <i class="fas fa-chevron-left"></i>
        </a>
      </div>
    </div>
    <div class="row">
      <div class="col-2">
        <label for=""><u>Filter by affiliate</u></label>
        <input type="text" class="form-control" placeholder="enter affiliate" [(ngModel)]="affiliateFilter" />
      </div>
      <div class="col-2 d-flex align-items-end">
        <button class="btn btn-primary btn-sm mr-2" (click)="search()">Search</button>
      </div>
      <div class="col-2 ml-auto">
        <label class="mb-0" for=""><u>Items Per Page</u></label>
        <select (change)="itemsPerPageChange($event.target.value)" class="form-control">
          <option *ngFor="let ipp of pagingList">{{ipp}}</option>
        </select>
      </div>

    </div>
  </div>
</div>
<div class="mt-3 mb-2 row">
  <div class="col-2 align-self-center">
    Total Results: {{totalItems}}
  </div>
  <div class="col-2 align-self-center" *ngIf="maxPageSize > 1">
    <label for=""><u>Go to page </u> <span class="small">(Max: {{maxPageSize}})</span></label>
    <input type="number" class="form-control form-control-sm" placeholder="Page" [(ngModel)]="goToPage" max="{{maxPageSize}}">
  </div>
  <div class="col-2 align-self-center" *ngIf="maxPageSize > 1">
    <button (click)="setPage(goToPage)" class="btn btn-sm btn-outline-primary">Go</button>
  </div>
  <div class="col-2 ml-auto text-right">
    <button class="btn btn-outline-success text-dark font-weight-bold" (click)="openModal(newAffiliateModal)" *ngIf="currentUser.roleName == 'ADMIN'">+ Affiliate</button>
  </div>
</div>
<!-- <div class="table-responsive"> -->
<table id="keywordList" class="table table-striped table-bordered mt-3 text-center" style="width:100%">
  <thead>
    <tr>
      <th>No.</th>
      <th>ShortCode</th>
      <th>Keyword</th>
      <th>Operator</th>
      <th>Affiliate</th>
      <th>Client</th>
      <th>Share</th>
      <th>Postback Min</th>
      <th>Postback Rate(%)</th>
      <th>Postback Cap</th>
      <th>Postback URL</th>
      <th *ngIf="currentUser.roleName == 'ADMIN'">Operate</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngIf="loading">
      <td colspan="13">
        <div class="loader">Loading...</div>
      </td>
    </tr>
    <tr *ngIf="emptyResult">
      <td colspan="13">
        <div class="alert alert-warning">Empty Result...</div>
      </td>
    </tr>
    <tr *ngFor="let affiliate of affiliates; index as i;">
      <td>{{i + 1}}</td>
      <td>{{affiliate.shortCode}}</td>
      <td>{{affiliate.keyword}}</td>
      <td>{{affiliate.operator}}</td>
      <td>{{affiliate.affiliate}}</td>
      <td><span *ngIf="!affiliate.managerName">-</span>
        <span *ngIf="affiliate.managerName">{{affiliate.managerName}}</span>
      </td>
      <td><span *ngIf="!affiliate.share">-</span>
        <span *ngIf="affiliate.share">{{affiliate.share}}</span>
      </td>
      <td class="text-left">
        MO: {{affiliate.moMin}} <br>
        DN: {{affiliate.dnMin}} <br>
        CNV: {{affiliate.cnvMin}}
      </td>
      <td class="text-left">
          MO: {{affiliate.moPostBackRate}} <br>
          DN: {{affiliate.dnPostBackRate}} <br>
          CNV: {{affiliate.cnvPostBackRate}}
        </td>
      <td class="text-left">
        MO: {{affiliate.moCap}} <br>
        DN: {{affiliate.dnCap}} <br>
        CNV: {{affiliate.cnvCap}}
      </td>
      <td class="text-left">
        MO: <a href="{{affiliate.moNotifyUrl}}"> {{affiliate.moNotifyUrl}}</a> <br>
        DN: <a href="{{affiliate.dnNotifyUrl}}"> {{affiliate.dnNotifyUrl}}</a> <br>
        CNV: <a href="{{affiliate.cnvUrl}}" target="_blank">{{affiliate.cnvUrl}}</a> <br>
      </td>
      <!-- <td>
          <a [routerLink]="['/dashboard/mt-detail', emp.id]">
            <span class="badge">view </span>
          </a>
        </td> -->
      <td *ngIf="currentUser.roleName == 'ADMIN'">
        <!-- <button type="button" class="btn btn-primary py-1 px-2"  placement="top" ngbTooltip="Tooltip on top">

          </button> -->
        <a type="button" class="btn btn-sm btn-primary mr-2 mt-2" placement="top" ngbTooltip="View & Edit" [routerLink]="['/dashboard/affiliate-detail', affiliate.id]">
          <i class="fas fa-pen"></i>
        </a>
        <button type="button" class="btn btn-sm btn-danger mr-2 mt-2" placement="top" ngbTooltip="Delete" (click)="deleteAffiliate(affiliate)">
          <i class="fas fa-trash"></i>
        </button>
      </td>
    </tr>
  </tbody>
  <tfoot>
    <tr>
      <td colspan="13" *ngIf="!loading && !emptyResult">
        <pagination [totalItems]="totalItems" [itemsPerPage]="itemsPerPage" [(ngModel)]="currentPage" [maxSize]="maxSize" class="pagination-md mb-0 justify-content-center" previousText="&lsaquo;" nextText="&rsaquo;" firstText="&laquo;"
          lastText="&raquo;" [boundaryLinks]="true" [rotate]="false" (numPages)="numPages = $event" (pageChanged)="pageChanged($event)"></pagination>
        <!-- <button (click)="setPage(2)">GO TO PAGE</button> -->
      </td>
    </tr>
  </tfoot>
</table>
<!-- </div> -->

<ng-template #newAffiliateModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="newAffiliateLable">New Affiliate</h5>
    <button type="button" class="close" (click)="modal.dismiss()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body" id="newAffiliate-modal-body">
    <form [formGroup]="newAffiliateForm" (ngSubmit)="onSubmit()">
      <small><i class="text-danger">* indicates mandatory field</i></small>
      <div class="form-group row p-2">
        <div class="col-sm-6">
          <label for="affiliate" class="col-form-label"><span class="text-danger">* </span>Affiliate: </label>
          <input type="text" class="form-control" formControlName="affiliate" placeholder="affiliate" maxlength="10">
          <div class="text-danger small" *ngIf="showError">
            <div *ngIf="f.affiliate.errors">
              Affiliate cannot be blank.
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <label for="moPostBackRate" class="col-form-label"><span class="text-danger">* </span>MO Postback Rate: <i class="fas fa-info-circle" placement="top" ngbTooltip="0-100"></i></label>
          <input type="number" class="form-control" formControlName="moPostBackRate" placeholder="100" min="0" max="100">
          <div class="text-danger small" *ngIf="showError">
            <div *ngIf="f.moPostBackRate.errors">
              Mo post-back rate cannot be blank.
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <label for="dnPostBackRate" class="col-form-label"><span class="text-danger">* </span>DN Postback Rate: <i class="fas fa-info-circle" placement="top" ngbTooltip="0-100"></i></label>
          <input type="number" class="form-control" formControlName="dnPostBackRate" placeholder="100" min="0" max="100">
          <div class="text-danger small" *ngIf="showError">
            <div *ngIf="f.dnPostBackRate.errors">
              Dn post-back rate cannot be blank.
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <label for="cnvPostBackRate" class="col-form-label"><span class="text-danger">* </span>Convertion Postback Rate: <i class="fas fa-info-circle" placement="top" ngbTooltip="0-100"></i></label>
          <input type="number" class="form-control" formControlName="cnvPostBackRate" placeholder="100" min="0" max="100">
          <div class="text-danger small" *ngIf="showError">
            <div *ngIf="f.cnvPostBackRate.errors">
              Cnv post-back rate cannot be blank.
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <label for="moMin" class="col-form-label"><span class="text-danger">* </span>Mo Postback Min: </label>
          <input type="number" class="form-control" formControlName="moMin" placeholder="0">
          <div class="text-danger small" *ngIf="showError">
            <div *ngIf="f.moMin.errors">
              Mo Min is required.
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <label for="dnMin" class="col-form-label"><span class="text-danger">* </span>Dn Postback Min: </label>
          <input type="number" class="form-control" formControlName="dnMin" placeholder="0">
          <div class="text-danger small" *ngIf="showError">
            <div *ngIf="f.dnMin.errors">
              Dn Min is required.
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <label for="cnvMin" class="col-form-label"><span class="text-danger">* </span>Cnv Postback Min: </label>
          <input type="number" class="form-control" formControlName="cnvMin" placeholder="0">
          <div class="text-danger small" *ngIf="showError">
            <div *ngIf="f.cnvMin.errors">
              Cnv Min is required.
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <label for="moCap" class="col-form-label"><span class="text-danger">* </span>Mo Postback Cap: </label>
          <input type="number" class="form-control" formControlName="moCap" placeholder="0">
          <div class="text-danger small" *ngIf="showError">
            <div *ngIf="f.moCap.errors">
              Mo Cap is required.
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <label for="dnCap" class="col-form-label"><span class="text-danger">* </span>Dn Postback Cap: </label>
          <input type="number" class="form-control" formControlName="dnCap" placeholder="0">
          <div class="text-danger small" *ngIf="showError">
            <div *ngIf="f.dnCap.errors">
              Dn Cap is required.
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <label for="cnvCap" class="col-form-label"><span class="text-danger">* </span>Cnv Postback Cap: </label>
          <input type="number" class="form-control" formControlName="cnvCap" placeholder="0">
          <div class="text-danger small" *ngIf="showError">
            <div *ngIf="f.cnvCap.errors">
              Cnv Cap is required.
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <label for="moNotifyUrl" class="col-form-label">Mo Postback URL: </label>
          <input type="text" class="form-control" formControlName="moNotifyUrl" placeholder="moNotifyUrl">
        </div>
        <div class="col-sm-6">
          <label for="dnNotifyUrl" class="col-form-label">Dn Postback URL: </label>
          <input type="text" class="form-control" formControlName="dnNotifyUrl" placeholder="dnNotifyUrl">
        </div>
        <div class="col-sm-6">
          <label for="cnvUrl" class="col-form-label">Conversion Postback URL: </label>
          <input type="text" class="form-control" formControlName="cnvUrl" placeholder="cnvUrl">
        </div>
        <div class="col-sm-6">
          <label for="managerId" class="col-form-label">Client</label>
          <select class="form-control" placeholder="Select" formControlName="managerId">
            <option value="">-select client-</option>
            <option *ngFor="let client of clientList" [value]="client.id">{{client.username}}</option>
          </select>
        </div>
        <div class="col-sm-6">
          <label for="share" class="col-form-label">Share: </label>
          <input type="text" class="form-control" formControlName="share" placeholder="share">
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Close</button>
        <button type="submit" class="btn btn-primary" *ngIf="!processing">Add Affiliate</button>
        <button type="submit" class="btn btn-primary" *ngIf="processing" disabled>Processing..</button>
      </div>
    </form>
  </div>
</ng-template>
